<template>
  <div class="tw:!max-w-4xl tw:!mx-auto">
    <div v-if="invoice" class="tw:!grid tw:md:!grid-cols-2 tw:!gap-3">
      <div>
        <div class="od-card" shadow>
          <div class="tw:!mb-4 tw:!flex">
            <div class="od-title">Payment checkout</div>
            <!-- <span v-if="common.stripe.clientId" class="tw:!h-8 tw:!w-10 tw:!mx-auto">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="#635bff">
                <path d="M492.4 220.8c-8.9 0-18.7 6.7-18.7 22.7l36.7 0c0-16-9.3-22.7-18-22.7zM375 223.4c-8.2 0-13.3 2.9-17 7l.2 52.8c3.5 3.7 8.5 6.7 16.8 6.7 13.1 0 21.9-14.3 21.9-33.4 0-18.6-9-33.2-21.9-33.1zM528 32L48 32C21.5 32 0 53.5 0 80L0 432c0 26.5 21.5 48 48 48l480 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48zM122.2 281.1c0 25.6-20.3 40.1-49.9 40.3-12.2 0-25.6-2.4-38.8-8.1l0-33.9c12 6.4 27.1 11.3 38.9 11.3 7.9 0 13.6-2.1 13.6-8.7 0-17-54-10.6-54-49.9 0-25.2 19.2-40.2 48-40.2 11.8 0 23.5 1.8 35.3 6.5l0 33.4c-10.8-5.8-24.5-9.1-35.3-9.1-7.5 0-12.1 2.2-12.1 7.7 0 16 54.3 8.4 54.3 50.7zM191 224.5l-27 0 0 50.5c0 20.9 22.5 14.4 27 12.6l0 28.9c-4.7 2.6-13.3 4.7-24.9 4.7-21.1 0-36.9-15.5-36.9-36.5l.2-113.9 34.7-7.4 0 30.8 26.9 0 0 30.3zm74 2.4c-4.5-1.5-18.7-3.6-27.1 7.4l0 84.4-35.5 0 0-124.5 30.7 0 2.2 10.5c8.3-15.3 24.9-12.2 29.6-10.5l.1 0 0 32.7zm44.1 91.8l-35.7 0 0-124.5 35.7 0 0 124.5zm0-142.9l-35.7 7.6 0-28.9 35.7-7.6 0 28.9zm74.1 145.5c-12.4 0-20-5.3-25.1-9l-.1 40.2-35.5 7.5 0-165.8 31.3 0 1.8 8.8c4.9-4.5 13.9-11.1 27.8-11.1 24.9 0 48.4 22.5 48.4 63.8 0 45.1-23.2 65.5-48.6 65.6zm160.4-51.5l-69.5 0c1.6 16.6 13.8 21.5 27.6 21.5 14.1 0 25.2-3 34.9-7.9l0 28.6c-9.7 5.3-22.4 9.2-39.4 9.2-34.6 0-58.8-21.7-58.8-64.5 0-36.2 20.5-64.9 54.3-64.9 33.7 0 51.3 28.7 51.3 65.1 0 3.5-.3 10.9-.4 12.9z"/>
              </svg>
            </span> -->
          </div>

          <!-- <StripCardPayment
            v-if="common.stripe.clientId"
            :invoice="invoice"
            @ready="secret => stripe.secret = secret"
            @success="handlePaymentIntent"
          /> -->

          <!-- <div v-if="common.stripe.clientId" class="tw:!flex tw:!justify-between tw:!space-x-3 tw:!mt-6 tw:!mb-2">
            <hr class="tw:!opacity-20 tw:!w-full tw:!self-center" />
            <span class="tw:!block tw:!whitespace-pre tw:opacity-60">OR</span>
            <hr class="tw:!opacity-20 tw:!w-full tw:!self-center" />
          </div> -->

          <PaypalPayment v-if="common.paypal.clientId" :invoice="invoice" @success="emit('success')" />
          <div v-if="common.stripe.clientId" class="tw:!border-b tw:!border-gray-300 tw:!mb-2"></div>

          <!-- <div v-if="common.stripe.clientId" class="tw:!mb-4">
            <Transition name="fade">
              <StripeExpressPayment
                v-if="stripe.secret"
                :amount="invoice.amount"
                :secret="stripe.secret"
                :contact="invoice.ticket.contact"
                @success="handlePaymentIntent"
              />
            </Transition>
          </div> -->
        </div>

        <p class="tw:!mt-4 tw:!px-4 tw:!text-base tw:!italic tw:!leading-relaxed">
          100% refund if the booking reference cannot be verified on the airline's website.<br>
          Free reissue if cancelled by the airline.
        </p>
      </div>

      <div>
        <div class="od-card">
          <div class="od-title">Reservation Details</div>

          <Variable v-if="invoice.ticket" :set="invoice.ticket" v-slot="flight">
            <div class="tw:!grid">
              <div class="tw:!flex tw:!w-full tw:!justify-between">
                <span class="tw:!text-lg tw:!opacity-70">Departure</span>
                <span class="tw:!text-lg tw:!font-light">
                  {{ dayjs(flight.from.departure).format('DD/MM/YYYY') }}
                  {{ flight.from.time }}
                </span>
              </div>
              <div class="tw:!flex tw:!justify-between">
                <span class="tw:!text-2xl tw:!font-medium tw:!font-mono">{{ flight.from.iata }}</span>
                <div class="tw:!grid tw:!place-content-center"><ArrowBigRightDash /></div>
                <span class="tw:!text-2xl tw:!font-medium tw:!font-mono">{{ flight.to.iata }}</span>
              </div>

              <Variable v-if="departureFlightInfo" :set="departureFlightInfo" v-slot="flight" >
                <div  class="tw:!mt-2 tw:!flex tw:!items-center tw:!gap-2">
                  <img
                    class="tw:!size-6 tw:!rounded"
                    :src="`https://static.tripcdn.com/packages/flight/airline-logo/latest/airline_logo/3x/${flight.company.marketing.code.toLowerCase()}.webp`"
                    :alt="flight.company.marketing.name"
                  />
                  <div class="tw:!text-sm tw:!opacity-70 tw:!flex tw:!gap-2">
                    <span>{{ flight.company.marketing.name }}</span>
                    <span class="tw:!font-mono">· {{ flight.company.marketing.code }}{{ flight.segments[0]!.number }}</span>
                    <span :class="flight.stops === 0 ? 'tw:!text-green-600' : 'tw:!text-orange-500'">
                      · {{ flight.stops === 0 ? 'Nonstop' : `${flight.stops} stop${flight.stops > 1 ? 's' : ''}` }}
                    </span>
                  </div>
                </div>

                <TransitDetail :segments="flight.segments" />
              </Variable>
            </div>
          </Variable>

          <Variable v-if="invoice.ticket.returning" :set="invoice.ticket.returning as AirplaneTicket" v-slot="flight">
            <div class="tw:!grid tw:!mt-5">
              <div class="tw:!flex tw:!w-full tw:!justify-between">
                <span class="tw:!text-lg tw:!opacity-70">Return</span>
                <span class="tw:!text-lg tw:!font-light">
                  {{ dayjs(flight.from.departure).format('DD/MM/YYYY') }}
                  {{ flight.from.time }}
                </span>
              </div>
              <div class="tw:!flex tw:!justify-between">
                <span class="tw:!text-2xl tw:!font-medium tw:!font-mono">{{ flight.from.iata }}</span>
                <div class="tw:!grid tw:!place-content-center"><ArrowBigRightDash /></div>
                <span class="tw:!text-2xl tw:!font-medium tw:!font-mono">{{ flight.to.iata }}</span>
              </div>

              <Variable v-if="returnFlightInfo" :set="returnFlightInfo" v-slot="flight" >
                <div  class="tw:!mt-2 tw:!flex tw:!items-center tw:!gap-2">
                  <img
                    class="tw:!size-6 tw:!rounded"
                    :src="`https://static.tripcdn.com/packages/flight/airline-logo/latest/airline_logo/3x/${flight.company.marketing.code.toLowerCase()}.webp`"
                    :alt="flight.company.marketing.name"
                  />
                  <div class="tw:!text-sm tw:!opacity-70 tw:!flex tw:!gap-2">
                    <span>{{ flight.company.marketing.name }}</span>
                    <span class="tw:!font-mono">· {{ flight.company.marketing.code }}{{ flight.segments[0]!.number }}</span>
                    <span :class="flight.stops === 0 ? 'tw:!text-green-600' : 'tw:!text-orange-500'">
                      · {{ flight.stops === 0 ? 'Nonstop' : `${flight.stops} stop${flight.stops > 1 ? 's' : ''}` }}
                    </span>
                  </div>
                </div>

                <TransitDetail :segments="flight.segments" />
              </Variable>
            </div>
          </Variable>

          <Variable v-if="invoice.ticket.passengers" :set="invoice.ticket.passengers" v-slot="passenger">
            <div class="tw:!mt-7">
              <div class="tw:!flex tw:!justify-between">
                <p class="tw:!text-lg tw:!opacity-70">Passengers</p>
                <p class="tw:!opacity-70">x{{ Object.keys(passenger).length }}</p>
              </div>

              <div class="tw:!text-2xl tw:!font-medium">
                <div v-for="item in passenger" class="tw:!leading-relaxed">
                  <span class="tw:!capitalize">{{ item.prefix.toLowerCase() }}. </span>
                  <span>{{ item.first_name }} / {{ item.family_name }}</span>
                </div>
              </div>
            </div>
          </Variable>

          <Variable v-if="invoice.prefer_duration" :set="invoice" v-slot="{ prefer_duration: duration }">
            <div v-if="duration === '7days'" class="tw:!mt-3 tw:flex tw:space-x-1">
              <!-- <Icon name="mdi:checkbox-outline" size="1rem" /> -->
              <p class="tw:!text-lg tw:!text-green-600">
                ✓ Valid 7 days tickets
              </p>
            </div>
          </Variable>

          <Variable v-if="invoice.ticket.contact" :set="invoice.ticket.contact!" v-slot="{ email, phone }">
            <div class="tw:!mt-7">
              <p class="tw:!text-lg tw:!font-medium tw:!opacity-90">Contact Booking</p>
              <div class="tw:!ml-1">
                <div class="tw:!block">• {{ phone }}</div>
                <div class="tw:!block">• {{ email }}</div>
              </div>
            </div>
          </Variable>

          <hr class="tw:!opacity-20 tw:!my-5">

          <p class="tw:!text-2xl tw:!font-semibold">Total: ${{ invoice.amount }}</p>
        </div>

        <div class="tw:!mt-3">
          <button class="od-button-outline" @click="emit('back')">Go Back</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export type PaymentInvoice = {
  _id: string
  prefer_duration?: '7days'
  ticket: AirplaneTicket,
  amount: number
  status: 'pending' | 'paid'
}

</script>

<script lang="ts" setup>
// import Card from '~/components/base/card/Card.vue'
// import Title from '~/components/base/title/Title.vue'
// import Button from '~/components/base/button/Button.vue'
import StripCardPayment from './StripCardPayment.vue'
import StripeExpressPayment from './StripeExpressPayment.vue'
import type { PaymentIntent } from '@stripe/stripe-js'
// import { useToast } from 'vue-toast-notification'
import dayjs from 'dayjs'
import { onMounted, reactive, ref } from 'vue'
import { axios, common } from '~/composables/general'
import type { AirplaneTicket, IFlight } from '~/types'
import Variable from './Variable.vue'
import TransitDetail from './TransitDetail.vue'
import PaypalPayment from './PaypalPayment.vue'


const props = defineProps<{
  invoice: string | PaymentInvoice
  departureFlightInfo?: IFlight
  returnFlightInfo?: IFlight
}>()

// const toast = useToast()
const invoice = ref<PaymentInvoice>()

const stripe = reactive({
  secret: ''
})

const emit = defineEmits<{
  back: [],
  success: []
}>()

typeof props.invoice !== 'string'
  ? invoice.value = props.invoice
  : await axios.get<PaymentInvoice>('/public/invoice/' + props.invoice)
    .then(data => invoice.value = data.data)
    .catch(() => emit('back'))

const handlePaymentIntent = async (paymentIntent: PaymentIntent) => {
  await axios.post(`/ticket/onward/invoice/${invoice.value?._id}/stripe/capture`, {
    payment_intent: paymentIntent.id
  })
  .then(() => {
    // toast.success('Payment confirmed', { position: 'top-right' })

    emit('success')
  })
  .catch(() => {
    // toast.error('Payment did not succeed', { position:'top-right' })
  })
}
</script>
